module.exports = {
	"Announcement": {
		"Know More": "了解更多"
	},
	"Appointment": {
		"Conditions": "點擊「確定」，即表示閣下確認已閱讀私隱政策，並同意%(brand)s在遵守私隱政策條款的前提下處理閣下的個人資料，以回應閣下的請求。",
		"Confirmation": "我們已收到您的精品店預約請求並聯繫一名顧問，以為您提供個人協助服務。您將收到一封確認電郵。",
		"Description": "Dior誠邀您與顧問預約並蒞臨精品店以獲得個人服務。",
		"Get an appointment": "預約",
		"Motives": "目的",
		"Universes": "主題世界"
	},
	"DiorMap": {
		"Search in this area": "於此區域搜尋"
	},
	"FilterBlock": {
		"%(count)s Results": {
			"one": "%(count)s 結果",
			"other": "%(count)s 結果",
			"zero": "%(count)s 結果"
		},
		"Refine": "篩選",
		"RefineAria": "使用下方勾選方格調整搜尋範圍",
		"Are you looking for?": "您正在尋找女士時裝、男士時裝、童裝、珠寶或腕錶精品店嗎？"
	},
	"Footer": {
		"Download the applications": "下載應用程式",
		"Language": "語言",
		"Newsletter": "如：Christian@dior.fr",
		"Ok": "確定",
		"Subscribe to newsletter": "訂閱Dior最新資訊"
	},
	"Form": {
		"All fields are mandatory": "所有欄目均為必填項",
		"Civility": "稱謂",
		"Comments": "正文",
		"Conditions": "您若希望收到由%(brand)s發送的確認電郵，請勾選上方空格。您擁有存取、修改、刪除和反對使用與您相關的個人資料的權利，並可以向「contact@dior.com」發送郵件以行使該權利。",
		"Date": "期望日期 ",
		"Email": "電郵",
		"Hour": "期望時段",
		"Invalid E-mail address": "無效的郵件地址",
		"Mr": "先生",
		"Mrs": "女士",
		"Name": "姓氏",
		"Phone": "電話",
		"Required fields": "必填字段",
		"Submit": "確定",
		"Surname": "名字"
	},
	"HeaderLight": {
		"Dior Boutiques near you: haute couture, fragrances, leather goods": "您居住城市裡的Dior精品店：高級訂製時裝、香氛、皮具",
		"Search for Dior shops": "Search for Dior shops",
		"Dior home logo": "DIOR home logo",
		"close boutique finder dialog": "close boutique finder dialog"
	},
	"Itinerary": {
		"Arrival": "抵達",
		"Departure": "離開",
		"Details": "詳情",
		"Error": "十分抱歉，我们未能取得所查询的有关路线，请修改出发地址及／或选用的交通并重新尝试。",
		"Follow the itinerary": "跟進路線",
		"Itinerary": "路線",
		"modeBICYCLING": "切換至騎自行車",
		"modeDRIVING": "切換至駕車",
		"modeTRANSIT": "切換至乘搭公共交通工具",
		"modeWALKING": "切換至步行",
		"Close dialog": "close dialog",
		"Print directions": "print directions"
	},
	"LayerOrientation": {
		"Use portrait": "請在縱向模式下使用您的手機"
	},
	"NavMobile": {
		"Home": "首頁"
	},
	"Newsletter": {
		"Dior Newsletter": "Dior最新資訊",
		"Fashion and accessories": "時裝及配飾",
		"I wish to receive the %(newsletter)s newsletter": "我希望接收關於%(newsletter)s的最新資訊",
		"Newsletter Confirmation": "您已訂閱Dior最新資訊",
		"Perfume and beauty": "香氛及美妝",
		"Receive our newsletter": "接收Dior最新資訊",
		"Your universes": "您的空間"
	},
	"ResultsBlock": {
		"Dior boutiques": "Dior精品店",
		"Too far": "搜尋結果太多，請縮小搜尋範圍以調整您的搜索。",
		"No result": "找不到商店",
		"Other shops": "其他精品店",
		"Results": "搜尋結果",
		"Fewer results, zoom in": "顯示較少結果, zoom in",
		"More results, zoom out": "顯示更多結果, zoom out",
		"Fewer results": "顯示較少結果",
		"More results": "顯示更多結果"
	},
	"SearchBlock": {
		"Geolocation": "使用地理位置尋找附近的商店",
		"Search": "搜尋"
	},
	"Share": {
		"Conditions": "您若希望收到由%(brand)s發送的確認電郵，請勾選上方空格。您擁有存取、修改、刪除和反對使用與您相關的個人資料的權利，並可以向「contact@dior.com」發送郵件以行使該權利。",
		"Recipient": "您的收件人",
		"Share Confirmation": "您的精品店資訊表已成功發送",
		"Share this shop": "分享精品店資訊",
		"Your favorite shop": "您所選的精品店"
	},
	"ShopBlock": {
		"Closed": "營業時間已過",
		"Closed today": "今天休息",
		"Directions": "路线",
		"DirectionsAria": "前往%(shopName)s的路線",
		"Make an appointment": "预约",
		"Open": "營業",
		"Opening time": "營業時間",
		"OpeningAria": "營業時間詳細資料",
		"ResultNumber": "結果編號%(number)s",
		"Services": "服務",
		"ServicesAria": "服務詳細資料",
		"Share": "分享",
		"Special hours": "Special hours",
		"Today until %(hour)s": "今天至 %(hour)s",
		"Universes": "主題世界",
		"UniversesAria": "更多有關Dior世界的資訊",
		"and": "and",
		"from": "from",
		"publicHolidays": "精品店營業時間可能已過",
		"to": "to"
	}
};


//////////////////
// WEBPACK FOOTER
// ./public/assets/locales/zh_hk/translations.json
// module id = 875
// module chunks = 0